import Footer from './components/Footer';
import FadeInSection from './components/FadeInSection';
import TechNavbar from './components/TechNavbar';
import AccordionSection from './components/Home/AccordionSection';
import HeroHome from './components/Home/HeroHome';
import ServicesSection from './components/Home/ServicesSection';
import Stats from './components/Home/Stats';
import WhyChooseUs from './components/Home/WhyChooseUs';
import ContactUs from './components/Home/ContactUs';
import MiniSection from './components/Home/MiniSection';
import CompanyPartners from './components/Home/CompanyPartners';
import ServicesCarousel from './components/Home/ServicesCarousel';
import ProjectsSection from './components/Home/ProjectsSection';


function App() {


  return (
    <div className="min-h-screen bg-white font-sans">

      <TechNavbar/>

      {/* MAIN PAGE HERO SECTION */}
      <FadeInSection>
        {/* <MainHeor/> */}
        <HeroHome/>
        
      </FadeInSection>

      {/* MINI SCREEN SECTION */}
      <FadeInSection>
      <MiniSection/>
      </FadeInSection>

      {/* EXPERTIES SECTION */}
      <FadeInSection>
        <ServicesSection/>
      </FadeInSection>

      {/* STATES SECTION */}
      <FadeInSection>
      <Stats/>  
      </FadeInSection>

      {/* WHY CHOOSE US SECTION */}
      <FadeInSection>
        <WhyChooseUs/>
      </FadeInSection>

      {/* COMPANIES WE WORK SECTION */}
      <FadeInSection>
      <CompanyPartners/>
      </FadeInSection>

      {/* SERVICES CAROUSEL SECTION */}
      <FadeInSection>
      <ServicesCarousel/>
      </FadeInSection>

      {/* OUR PROJECTS SECTION */}
      <FadeInSection>
      <ProjectsSection/>
      </FadeInSection>

      {/* ACCORDION SECTION */}
      <FadeInSection>
        <AccordionSection/>
      </FadeInSection>

      {/*  CUSTOMERS REVIEW SECTION */}
      <FadeInSection>
        <ContactUs/>
      </FadeInSection>

      {/* FOOTER SECTION */}
      <Footer />

    </div>
  );
}

export default App;
